<template>
  <div class="d-flex fill-height">
    <parameter-card
      class="parameter-card"
      :title="
        t('parameter.selected_parameters') +
          ` (${parameterStore.selectedParameters.length}/${parameterStore.allParameters.length})`
      "
      :items="parameterStore.allParameters"
      :selected="parameterStore.selectedParameters"
      @selected-changed="selectParams($event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ParameterStore from '@/stores/parameter/parameter-module';
import { Parameter } from '@/stores/parameter/parameter-model';
import ParameterCard from '@/components/common/ParameterCard.vue';
import { useI18n } from "vue-i18n";

export default defineComponent ({
  name: 'ParameterSelectionPage',
  components: {
    ParameterCard,
  },
  setup() {
    const { t } = useI18n();

    const parameterStore = ParameterStore;

    function selectParams(selectedParams: Parameter[]): void {
      parameterStore.updateSelectedParameters(selectedParams);
    };

    function resetParameters(): void {
      parameterStore.updateSelectedParameters([]);
    };

    return {
      t,
      parameterStore,
      selectParams,
      resetParameters,
    };
  },
})
</script>

<style scoped>
.parameter-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
